<template>
    <DialogLayout>
        <div class="AlertModal">
            <i class="AlertModal__icon" :class="icon"/>
            <h3 class="AlertModal__title">{{ title }}</h3>
            <p class="AlertModal__text" v-html="content"></p>
            <div class="text-center" v-if="closeButton" @click="handleClose">
                <button class="Btn Btn--primary Btn--gradient Btn--shadow">
                    <span>Fermer</span>
                </button>
            </div>
            <div v-if="buttons.length > 0" class="AlertModal__buttons">
                <button v-for="(button, index) in buttons" @click="e => handleClick(e, button, index)" type="button" :class="button.class">
                    <i v-if="loadingButton === index" class="fas fa-spinner fa-spin"></i>
                    <span v-if="loadingButton !== index" v-html="button.label"></span>
                </button>
            </div>
        </div>
    </DialogLayout>
</template>

<script>
    import ModalBus from "../../eventBus";
    import DialogLayout from "./Layouts/DialogLayout";

    export default {
        components: {DialogLayout},
        data: function(){
            return {
                loadingButton: null,
            }
        },
        props: {
            icon: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            content: {
                type: String,
                required: true
            },
            closeButton: {
                type: Boolean,
                default: true
            },
            buttons: {
                type: Array,
                default: []
            }
        },
        methods: {
            handleClick: async function(e, button, index){
                if(button.loading){
                    this.loadingButton = index;
                    await button.onClick(e);
                    this.loadingButton = null;
                }else{
                    button.onClick(e);
                }
            },
            handleClose: function () {
                ModalBus.$emit('close');
            }
        }
    }
</script>
